import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { syncDocumentHtmlLangAndDir } from "../utils/documentLanguage";
import { i18nResources } from "./resources";

/** Languages exposed in the UI language selector (must stay in sync with LiveTranslationDropdown). */
export const SUPPORTED_UI_LANGUAGES = [
  "en",
  "fr",
  "nl",
  "it",
  "es",
  "ar",
  "zh",
  "pt",
] as const;

const resources = i18nResources;

const LANGUAGE_STORAGE_KEY = "smbf.portal.language";

const supportedSet = new Set<string>(SUPPORTED_UI_LANGUAGES);

function normalizeStoredLanguage(raw: string | null): string {
  const code = (raw || "en").split("-")[0]?.toLowerCase() ?? "en";
  return supportedSet.has(code) ? code : "en";
}

const initialLanguage =
  typeof window !== "undefined"
    ? (() => {
        const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        const normalized = normalizeStoredLanguage(stored);
        const storedCode = stored?.split("-")[0]?.toLowerCase();
        if (stored && storedCode !== normalized) {
          window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
        }
        return normalized;
      })()
    : "en";

i18n.use(initReactI18next).init(
  {
    resources,
    lng: initialLanguage,
    fallbackLng: "en",
    load: "languageOnly",
    supportedLngs: [...SUPPORTED_UI_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  },
  () => {
    syncDocumentHtmlLangAndDir(i18n.language);
  }
);

const i18nAny = i18n as typeof i18n & {
  on?: (event: string, cb: (lng: string) => void) => void;
};
i18nAny.on?.("languageChanged", (lng: string) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  }
  syncDocumentHtmlLangAndDir(lng);
});

export default i18n;
